export default __webpack_public_path__ + "media/images/features/local_delivery/episode1/LP_05-2ae068cf0e6b01e827a85d950dcab9ff.jpg";